import {config} from "../../MedicareAdvantage/config/config";

export function GetPlansYear(): '2022' | '2023' {
  return '2023';
}
